
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";

const PaymentCanceled = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const navigate = useNavigate();

  return (
    <div className="bg-[#0f141c] min-h-screen">
      <Navbar />
      
      <div className="container max-w-4xl mx-auto pt-28 px-4">
        <div className="bg-[#1A2233] border border-[#223342] rounded-xl p-8 text-center">
          <div className="py-12">
            <div className="flex justify-center mb-6">
              <XCircle className="h-24 w-24 text-red-500" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-4">
              Pagamento Cancelado
            </h1>
            <p className="text-gray-300 text-lg mb-8">
              O pagamento foi cancelado. Sua reserva será mantida por um curto período,
              mas será cancelada automaticamente se o pagamento não for concluído.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                onClick={() => navigate('/mentorias')}
                className="bg-[#00B6F0] hover:bg-[#0090C0] text-black"
              >
                Explorar Mentorias
              </Button>
              <Button 
                onClick={() => sessionId ? navigate(`/payment-retry?session_id=${sessionId}`) : navigate('/painel-jogador')}
                variant="outline"
                className="border-[#223342] hover:bg-[#1E293B]"
              >
                Tentar Novamente
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCanceled;
